import { format, subDays, startOfMonth, endOfMonth, subMonths } from 'date-fns';

export const OVERVIEW_TIME_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: '7days', label: 'Last 7 Days' },
  { value: 'month', label: 'This Month' },
];

export const getTimeRangeLabel = (range) =>
  OVERVIEW_TIME_RANGE_OPTIONS.find((o) => o.value === range)?.label || 'Today';

/** Local calendar dates for overview card filtering (sales + expenses). */
export const getOverviewDateRange = (timeRange) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let startDate = new Date(today);
  let endDate = new Date(today);

  if (timeRange === 'yesterday') {
    startDate = subDays(today, 1);
    endDate = subDays(today, 1);
  } else if (timeRange === '7days') {
    startDate = subDays(today, 6);
    endDate = today;
  } else if (timeRange === 'month') {
    startDate = startOfMonth(today);
    endDate = today;
  }

  return {
    startDate: format(startDate, 'yyyy-MM-dd'),
    endDate: format(endDate, 'yyyy-MM-dd'),
    isToday: timeRange === 'today',
  };
};

export const BEST_SELLERS_PERIOD_OPTIONS = [
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
];

/** Date range for dashboard best-sellers widget. */
export const getBestSellersDateRange = (period = 'thisMonth') => {
  const today = new Date();

  if (period === 'lastMonth') {
    const lastMonth = subMonths(today, 1);
    return {
      startDate: format(startOfMonth(lastMonth), 'yyyy-MM-dd'),
      endDate: format(endOfMonth(lastMonth), 'yyyy-MM-dd'),
    };
  }

  return {
    startDate: format(startOfMonth(today), 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd'),
  };
};
